import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import { ApiService } from './api.service'

@Injectable({
  providedIn: 'root',
})
export class UiStateService {
  constructor(private apiService: ApiService) {}

  /**
   * Read current account UI state from backend.
   */
  load(accountId: string): Observable<Record<string, string>> {
    return this.apiService.getAccountUiState(accountId)
  }

  /**
   * Merge keysToWrite into the existing backend state and save.
   * - Reads current state
   * - If clearPrefix is provided, removes keys matching that prefix from existing state
   * - Merges keysToWrite overtop
   * - Writes back the merged result
   *
   * On read failure, falls back to writing just keysToWrite.
   */
  save(accountId: string, keysToWrite: Record<string, string>, clearPrefix?: string): Observable<void> {
    return this.apiService.getAccountUiState(accountId).pipe(
      catchError(() => of(null)),
      map((existingState) => {
        const base = { ...(existingState || {}) }

        if (clearPrefix) {
          for (const key of Object.keys(base)) {
            if (key.startsWith(clearPrefix)) {
              delete base[key]
            }
          }
        }

        return { ...base, ...keysToWrite }
      }),
      switchMap((merged) => this.apiService.updateAccountUiState(accountId, merged))
    )
  }
}
